/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
import EdenComingSoon from "../components/page-sections/eden-coming-soon/EdenComingSoon";

const Eden = (props) => {
  return (
    <React.Fragment>
      <Layout
        hideFooter={true}
        hideFabs={true}
        // hideNavLinks={true}
        // hideNavbar={true}
        backgroundPlaceholder={true}
      >
        <EdenComingSoon liveIn={props.liveIn} />
      </Layout>
    </React.Fragment>
  );
};

Eden.getInitialProps = async () => {
  const liveIn = (
    await (
      await fetch("https://sentientdevelopers.com/api/website-config")
    ).json()
  )[0].liveIn;
  return { liveIn: new Date(liveIn).toString() };
};

export default Eden;
